import Repository from "../Repository";
import { getAuthHeader } from "../../_helpers/apiHelper";
import { apiConfig } from "@/_helpers/apiHelper";

const resource = "/roles";

export default {
  getAllByCompany(user, companyId) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.get(`${resource}/${companyId}`, config);
  },

  getPermissions(user) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.get(`${resource}/permissions`, config);
  },

  getRecommendedPermissions(payload) {
    return Repository.post(
      `${resource}/recommended-permissions`,
      payload,
      apiConfig()
    );
  },

  getUserPermissionsByUserId(user) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.get(`${resource}/current-user-permissions`, config);
  },

  create(user, companyId, payload) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.post(`${resource}/${companyId}`, payload, config);
  },

  update(user, userRoleId, payload) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.put(`${resource}/${userRoleId}`, payload, config);
  },

  delete(userRoleId) {
    return Repository.delete(`${resource}/${userRoleId}`, apiConfig());
  },
};
